import React, { useEffect } from 'react';
import _ from 'lodash';
import { Route, Switch, Router, Link, useRoute } from 'wouter';
import { useDispatch } from 'react-redux';
import { actions } from '@/store/store.js';
import PodRenderer from "@/components/PodRenderer.jsx";
import { useFeatures } from '@/functions/DataEnv.js';
import ScrollTopOnNavigation from "@/components/ScrollTopOnNavigation.jsx";

const AppMain = () => {
    const features = useFeatures(); // Features are MediaFolios

    const [isRootRoute] = useRoute('/main');
    const landingPageRootRoute = (feature) => isRootRoute && feature.identity === 'mf-site-main';
    const nestedRouteMatcher = (feature) => !!window.location.pathname.split('/')[2]?.match(feature.identity);

    const siteMainFeature = features.find((feature) => feature.identity === 'mf-site-main');
    const siteMainPod = _.get(siteMainFeature, 'pods')[0];
    const isSiteMain = (feature) => feature.identity === 'mf-site-main';
    const getPath = (feature) => feature.identity === 'mf-site-main' ? '' : feature.identity;

    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(actions.initialState.setInitialState(data_env));
    }, []);

    return (
        <div className="app-main" style={{ flexGrow: 1 }}>
            <Switch>
                <Router base='/main'>
                    <ScrollTopOnNavigation />
                    <Route>
                        <div className="navigation">
                            {features.map((feature) => (
                                <Link
                                    to={`/${getPath(feature)}`}
                                    className={(active) => `nav-button ${active || landingPageRootRoute(feature) || nestedRouteMatcher(feature) ? 'selected' : ''}`}
                                    key={feature.identity}
                                >{feature.navTitle}</Link>
                            ))}
                        </div>
                    </Route>
                    <Route path="/">
                        {() => <PodRenderer pods={siteMainFeature.pods} podule={siteMainPod} />}
                    </Route>
                    {features.filter(f => !isSiteMain(f)).map(feature => (
                        <Route path={`/${feature.identity}`} key={feature.identity} nest>
                            <Route path="/">
                                <PodRenderer feature={feature} podule={feature.pods[0]} pods={feature.pods} />
                            </Route>
                            {feature.pods?.map((pod) => (
                                <Route path={`/${pod.identity}`} key={pod.identity}>
                                    <PodRenderer feature={feature} podule={pod} pods={feature.pods} />
                                </Route>
                            ))}
                        </Route>
                    ))}
                </Router>
            </Switch>
        </div>
    );
};

export default AppMain;
